// eslint-disable-next-line func-names
export default function nextStep() {
  let activeHeading = 1;
  const allHeadings = document.getElementsByClassName('how-it-works__item--header');
  const list = document.getElementsByClassName('how-it-works__item--list');
  const text = document.getElementsByClassName('how-it-works__item--text');
  const buttonOrder = document.getElementById('place_order');
  const buttonNextStep = document.getElementById('next_step');
  // eslint-disable-next-line func-names

  function changeText() {
    Array.from(allHeadings).forEach((heading, index) => {
      if (index !== activeHeading) {
        heading.classList.add('hidden');
      } else {
        heading.classList.remove('hidden');
      }
    });
    activeHeading += 1;

    if (activeHeading === allHeadings.length) {
      list[0].classList.add('hidden');
      text[0].classList.remove('hidden');
      buttonOrder.classList.remove('hidden');
      buttonNextStep.classList.add('invisible');

      // eslint-disable-next-line no-use-before-define
      clearInterval(interval);
    }
  }

  const interval = setInterval(changeText, 5000);

  // eslint-disable-next-line func-names
  buttonNextStep.onclick = function() {
    changeText();
  };
}
